export enum ImageType {
  PROFILE = 'PROFILE',
  DOCUMENT = 'DOCUMENT',
}
